import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-601264be")
const _hoisted_1 = { class: "account-wrapper" }
const _hoisted_2 = ["aria-expanded"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_AccountDropdown = _resolveComponent("AccountDropdown")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args))),
      class: _normalizeClass({ 'is-active': _ctx.isDropdownOpen }),
      "aria-haspopup": "true",
      "aria-expanded": _ctx.isDropdownOpen
    }, [
      _createVNode(_component_svg_icon, {
        class: "icon icon-account",
        src: `icons/account-dark.svg`
      }, null, 8, ["src"])
    ], 10, _hoisted_2),
    _createVNode(_component_AccountDropdown, {
      class: _normalizeClass({ 'is-open': _ctx.isDropdownOpen }),
      "is-auth": _ctx.isUserAuth
    }, null, 8, ["class", "is-auth"])
  ], 512)), [
    [_directive_click_outside, _ctx.closeDropdown]
  ])
}